import { render, staticRenderFns } from "./ConfirmSyncVideoModal.vue?vue&type=template&id=a647ac42&scoped=true&"
import script from "./ConfirmSyncVideoModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmSyncVideoModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmSyncVideoModal.vue?vue&type=style&index=0&id=a647ac42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a647ac42",
  null
  
)

export default component.exports